import React, { useState, useEffect } from "react";
import { getDevApplicationState } from "./devApplicationGlobal";
import { EntityKind } from "../game/state/entityKinds";
import { getDevEmitter, dev_event } from "./devEvents";

const entities = [
  {
    kind: EntityKind.StaticWall,
  },
  { kind: EntityKind.Crate },
  { kind: EntityKind.Empty },
  { kind: EntityKind.WinLevel },
  { kind: EntityKind.MeleeEnemy },
  { kind: EntityKind.Door },
  { kind: EntityKind.PressurePlate },
  { kind: EntityKind.PlayerBody },
  { kind: EntityKind.ExtendedBlock },
  { kind: EntityKind.LazorToggle },
];

export const EntityPalette = () => {
  const [selEntity, setSelEntity] = useState(EntityKind.StaticWall);
  const [editting, setEditting] = useState(false);
  useEffect(() => {
    const handler = () => {
      // Default mode
      setSelEntity(EntityKind.StaticWall);
      setEditting(true);
    };
    const handler2 = () => {
      setEditting(false);
    };

    getDevEmitter()?.addListener(dev_event.EDIT_LEVEL, handler);
    getDevEmitter()?.addListener(dev_event.SKIP_TO_LEVEL, handler2);
    return () => {
      getDevEmitter()?.removeListener(dev_event.EDIT_LEVEL, handler);
      getDevEmitter()?.removeListener(dev_event.SKIP_TO_LEVEL, handler2);
    };
  }, []);
  const dev = getDevApplicationState();
  if (editting) {
    return (
      <ul className="entity-palette active-buttons">
        {entities.map(({ kind }) => (
          <li
            key={kind}
            className={selEntity === kind ? "active" : ""}
            onClick={() => {
              setSelEntity(kind);
              dev?.changeEntityToPaint(kind);
            }}
          >
            {kind}
          </li>
        ))}
      </ul>
    );
  } else {
    return <span>No entities in play mode</span>;
  }
};
